import { useMutation } from '@tanstack/react-query';
import { merchantApi } from '@/api/merchant.api';
import type {
  EmailOtpRequestResponse,
  EmailOtpVerifyRequest,
  EmailOtpVerifyResponse,
  ForgotPasswordResponse,
} from '@/api/merchant.api';
import { ApiError } from '@/api/baseApi';

export interface RequestEmailOtpParams {
  email: string;
}

export const useRequestEmailOtpMutation = () => {
  return useMutation<EmailOtpRequestResponse, ApiError, RequestEmailOtpParams>({
    mutationFn: ({ email }) => merchantApi.requestEmailOtp(email),
  });
};

export const useVerifyEmailOtpMutation = () => {
  return useMutation<EmailOtpVerifyResponse, ApiError, EmailOtpVerifyRequest>({
    mutationFn: (request) => merchantApi.verifyEmailOtp(request),
  });
};

export interface ForgotPasswordParams {
  email: string;
}

export const useForgotPasswordMutation = () => {
  return useMutation<ForgotPasswordResponse, ApiError, ForgotPasswordParams>({
    mutationFn: ({ email }) => merchantApi.forgotPassword(email),
  });
};

export interface ConfirmPasswordResetParams {
  resetToken: string;
}

export const useConfirmPasswordResetMutation = () => {
  return useMutation<ForgotPasswordResponse, ApiError, ConfirmPasswordResetParams>({
    mutationFn: ({ resetToken }) => merchantApi.confirmPasswordReset(resetToken),
  });
};